<template>
  <div id="home" class="content md-layout md-gutter md-alignment-center-center">
    <div class="md-layout-item">
      <h1>{{ $t("Home") }}</h1>
      <br>
      <p>{{ $t("description") }}</p>
      <br>
      <h2>{{ $t("senna-quote") }}<br><br>Ayrton Senna</h2>
    </div>
    <div class="senna" alt="Ayrton Senna" title="Ayrton Senna" :style="{ 'background-image': 'url(' + require('@/assets/senna.jpg') +')' }"></div>
  </div>
</template>

<script>

export default {
  name: 'Home',
  title: 'Fabrício Ceschin - Home',
  props: {
    // msg: String,
    // num: Number
  },
  mounted() {
    this.$ga.page('/');
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#home {
  text-align:center;
}

#home img {
  width: 100%;
}

.senna {
  height: 475px;
  width: 100%;
  background-size: cover;
  background-position: center;
}

</style>
